import { BorderGridContainer, H2, PortableText } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import React from 'react';

import { Container, FlexContainerColumn, OuterContainer, StyledGridBox, StyledImage } from './styles';
import { PromotionsProps } from './types';
import offerTagImage from '../../../../components/offers/images/offer-tag.svg';

const Promotions = ({ promotions }: PromotionsProps) => (
  <>
    {map(
      (promotion) => (
        <BorderGridContainer>
          <StyledGridBox>
            <OuterContainer>
              <Container>
                <StyledImage src={offerTagImage.src} alt="Offer" />
                <FlexContainerColumn>
                  <H2 looksLike="h4">
                    <PortableText source={promotion.name} />
                  </H2>
                  <PortableText source={promotion.description} />
                </FlexContainerColumn>
              </Container>
            </OuterContainer>
          </StyledGridBox>
        </BorderGridContainer>
      ),
      promotions,
    )}
  </>
);

export default Promotions;
